import { Button, DatePicker, Form, Input, Modal, Switch, TimePicker, Upload, message, Progress, Spin } from 'antd';
import axios from '../../backendService';
import React, { useEffect, useState } from 'react';
import { MdAddBox } from 'react-icons/md';
import { LuUpload } from 'react-icons/lu';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { app } from '../../config/firbase-config';
import ExistingVideosModal from './ExistingVideosModal';
import Cookies from 'js-cookie';

const { TextArea } = Input;

// const instance = axios.create({
//   baseURL: 'http://localhost:4000', // Replace with your backend URL
//   timeout: 5000, // Set the timeout for requests (optional)
//   headers: {
//     'Content-Type': 'multipart/form-data', // Adjust the content type as per your backend requirements
//   },
// });

const AddVideoModal = ({ isVisible, handleCancel, topicId }) => {
  const [form] = Form.useForm();
  const [publish, setPublish] = useState(true);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState('');
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [showUploadBar, setShowUploadBar] = useState(false);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [videoURL, setVideoURL] = useState('');

  const [teacherId, setTeacherId] = useState('');
  const [teacherName, setTeacherName] = useState('');
  const [subjectName, setSubjectName] = useState('');
  const [subjectId, setSubjectId] = useState('');
  const [chapterName, setChapterName] = useState('');
  const [chapterId, setChapterId] = useState('');
  const [topicName, setTopicName] = useState('');

  const handleFileUpload = (file) => {
    const storage = getStorage(app);
    const fileName = file.name + '_' + new Date();
    const storageRef = ref(storage, fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);
    setShowUploadBar(true);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadPercentage(progress);
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case 'paused':
            console.log('Upload is paused');
            break;
          case 'running':
            console.log('Upload is running');
            break;
        }
      },
      (error) => {
        setShowUploadBar(false);
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;

          // ...

          case 'storage/unknown':
            // Unknown error occurred, inspect error.serverResponse
            break;
        }
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          // message.success('Video is ready to upload');
          console.log('File available at', downloadURL);
          setVideoURL(downloadURL);
        });
      },
    );
  };

  const onSubmitHandler = async (values) => {
    console.log(values);

    setLoading(true);
    const date = form.getFieldValue('publishDate').format('YYYY-MM-DD');
    const time = form.getFieldValue('publishTime').format('HH:mm');
    // const extractedVideoFile = form.getFieldValue('videoFile')[0]['originFileObj'];

    const formData = new FormData();
    // formData.append('videoFile', extractedVideoFile);
    formData.append('videoURL', videoURL);
    formData.append('title', values.title);
    formData.append('description', values.description);
    // formData.append('publish', publish);
    formData.append('publishDate', date);
    formData.append('publishTime', time);
    formData.append('teacher', teacherId);
    formData.append('chapter', chapterId);
    formData.append('subject', subjectId);
    formData.append('topic', topicId);

    formData.forEach((value, key) => {
      console.log(key, value);
    });

    try {
      const res = await axios.post('/videos/upload', formData);
      setLoading(false);
      // console.log(res.data);
      // setVideoUrl(res.data.videoURL)
      clearUploadedFile();
      form.resetFields();
      handleCancel();
      message.success('Lecture uploaded, Please refresh page once to see the changes');
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err.message);
      setLoading(false);
    }
  };

  const clearUploadedFile = () => {
    form.setFieldValue('videoFile', null);
    setShowUploadBar(false);
    setUploadPercentage(0);
    setFile('');
  };

  const closeExistingVideoModal = () => {
    setOpenVideoModal(false);
  };

  const getTeacherSubjectChapterData = async () => {
    try {
      const responseForSubjectChapter = await axios.get(`http://localhost:8000/topics/${topicId}`);
      // console.log(responseForSubjectChapter.data.data);
      const subjectChapterData = await responseForSubjectChapter.data.data;
      setSubjectId(subjectChapterData.subject && subjectChapterData.subject._id ? subjectChapterData.subject._id : '');
      setSubjectName(
        subjectChapterData.subject && subjectChapterData.subject.subjectName
          ? subjectChapterData.subject.subjectName
          : '',
      );
      setChapterId(subjectChapterData.chapter && subjectChapterData.chapter._id ? subjectChapterData.chapter._id : '');
      setChapterName(
        subjectChapterData.chapter && subjectChapterData.chapter.chapterName
          ? subjectChapterData.chapter.chapterName
          : '',
      );
      setTopicName(subjectChapterData.topicName);
      // console.log(subjectChapterData);
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err.message);
    }

    try {
      const userId = Cookies.get('userId');
      const responseForTeacher = await axios.get(`http://localhost:8000/users/${userId}`);
      // console.log(responseForTeacher.data.data.data.user.userName);
      const teacherData = await responseForTeacher.data.data.data.user;
      setTeacherId(userId);
      setTeacherName(teacherData.userName);
      // console.log(teacherData);
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err.message);
    }
  };

  useEffect(() => {
    getTeacherSubjectChapterData();
  }, [topicId]);

  return (
    <>
      <Modal
        title="Upload video lecture"
        open={isVisible}
        onCancel={handleCancel}
        style={{ top: 20 }}
        footer={null}
        width={1000}
      >
        <Form
          form={form}
          disabled={loading}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 24 }}
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={(values) => onSubmitHandler(values)}
          // onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name={'videoURL'}
            label="Video File"
            rules={[
              {
                required: false,
                message: 'Please upload a video file',
              },
            ]}
            className="mb-4"
          >
            <>
              <Form.Item className="mb-2">
                <div className="flex items-center gap-3 justify-start">
                  <Upload
                    maxCount={1}
                    beforeUpload={(file) => {
                      return new Promise((resolve, reject) => {
                        if (file.type === 'video/mp4' || file.type === 'video/mkv' || file.type === 'video/avi') {
                          resolve('Success');
                        } else {
                          message.error('Only mp4,avi,mkv video files are allowed');
                          reject('Only mp4,avi,mkv video files are allowed');
                        }
                      });
                    }}
                    customRequest={(info) => {
                      handleFileUpload(info.file);
                      setFile(info.file.name);
                    }}
                    showUploadList={false}
                  >
                    <div className="flex gap-4 items-center">
                      <Button className="flex items-center justify-center gap-2">
                        Add new video
                        <MdAddBox className="w-4 h-4" color="green" />
                      </Button>
                    </div>
                  </Upload>
                  <Button onClick={() => setOpenVideoModal(true)} className="flex items-center justify-center gap-2">
                    Select from existing
                    <LuUpload className="w-4 h-4" color="blue" />
                  </Button>
                </div>
              </Form.Item>
              {/* {
              file && uploadPercentage > 0 ? file : <p>Select a new video or a previously uploaded lecture.</p>} */}
              {file ? file : <p>Select a new video or a previously uploaded lecture.</p>}
              {file !== '' && (
                <Button onClick={clearUploadedFile} type="default" size="small" className="bg-red-500 text-white ml-2">
                  Delete
                </Button>
              )}
              {uploadPercentage > 0 && showUploadBar && <Progress percent={uploadPercentage} showInfo={false} />}
            </>
          </Form.Item>
          <Form.Item
            name={'title'}
            label="Title to display"
            rules={[
              {
                required: true,
                message: 'Please enter video title',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item name={'description'} label="Description to display" required>
            <TextArea rows={4} required />
          </Form.Item>
          <Form.Item name={'publishDate'} label="DatePicker" required>
            <DatePicker format={'YY:mm:dd'} required />
          </Form.Item>
          <Form.Item name={'publishTime'} label="TimePicker" required>
            <TimePicker format={'HH:mm'} required />
          </Form.Item>
          <Form.Item
            name={'teacher'}
            label="Teacher"
            rules={[
              {
                required: false,
                message: 'Must select a teacher',
              },
            ]}
          >
            <Input value={teacherId} placeholder={teacherName} disabled />
          </Form.Item>
          <Form.Item
            name={'subject'}
            label="Subject"
            rules={[
              {
                required: false,
                message: 'Must select a subject',
              },
            ]}
          >
            <Input value={subjectId} placeholder={subjectName} disabled />
          </Form.Item>
          <Form.Item
            name={'chapter'}
            label="Chapter"
            rules={[
              {
                required: false,
                message: 'Must select a chapter',
              },
            ]}
          >
            <Input value={chapterId} placeholder={chapterName} disabled />
          </Form.Item>
          <Form.Item
            name={'topic'}
            label="Topic"
            rules={[
              {
                required: false,
                message: 'Must select a topic',
              },
            ]}
          >
            <Input value={topicId} placeholder={topicName} disabled />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
            <Button type="primary" className="bg-blue-500" htmlType="submit" style={{ width: '100%' }}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <ExistingVideosModal
        isOpen={openVideoModal}
        videoPlayerClose={closeExistingVideoModal}
        setVideoURL={setVideoURL}
        setFile={setFile}
      />
    </>
  );
};

export default AddVideoModal;
